// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section {
  background: #fafafa;
  width: calc(100% - 48px);
  margin: 0 24px 24px 24px;
  padding: 24px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}
.section.fill {
  min-height: calc(100% - 24px);
}
@media (min-width: 0px) {
  .section.left {
    margin: 0 24px 24px 24px;
    width: calc(100% - 48px);
  }
  .section.right {
    margin: 0 24px 24px 24px;
    width: calc(100% - 48px);
  }
  .section.middle {
    margin: 0 24px 24px 24px;
    width: calc(100% - 48px);
  }
}
@media (min-width: 992px) {
  .section.left {
    margin-right: 12px;
    width: calc(100% - 24px);
  }
  .section.right {
    margin-left: 4px;
    width: calc(100% - 24px);
  }
  .section.middle {
    margin-left: 12px;
    width: calc(100% - 24px);
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/.pnpm/@nackle+studio-tools@1.9.9_@types+react@18.3.12_antd@5.24.6_date-fns@2.30.0_moment@2.30.1_rea_phmwef3nwavhog6egt6kd254om/node_modules/@nackle/studio-tools/dist/components/section/section.less"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,wBAAA;EACA,wBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AACJ;AAEA;EACI,6BAAA;AAAJ;AAGA;EACI;IACI,wBAAA;IACA,wBAAA;EADN;EAIE;IACI,wBAAA;IACA,wBAAA;EAFN;EAKE;IACI,wBAAA;IACA,wBAAA;EAHN;AACF;AAMA;EACI;IACI,kBAAA;IACA,wBAAA;EAJN;EAOE;IACI,gBAAA;IACA,wBAAA;EALN;EAQE;IAEI,iBAAA;IACA,wBAAA;EAPN;AACF","sourcesContent":[".section {\n    background: #fafafa;\n    width: calc( 100% - 48px);\n    margin: 0 24px 24px 24px;\n    padding: 24px;\n    border: 1px solid rgba(230, 230, 230, 1);\n    border-radius: 4px;\n}\n\n.section.fill {\n    min-height: calc(100% - 24px);\n}\n\n@media (min-width: 0px) {\n    .section.left {\n        margin: 0 24px 24px 24px;\n        width: calc( 100% - 48px);\n    }\n\n    .section.right {\n        margin: 0 24px 24px 24px;\n        width: calc( 100% - 48px);\n    }\n\n    .section.middle {\n        margin: 0 24px 24px 24px;\n        width: calc( 100% - 48px);\n    }\n}\n\n@media (min-width: 992px) {\n    .section.left {\n        margin-right: 12px;\n        width: calc( 100% - 24px);\n    }\n\n    .section.right {\n        margin-left: 4px;\n        width: calc( 100% - 24px);\n    }\n\n    .section.middle {\n        margin-left: 12px;\n        margin-left: 12px;\n        width: calc( 100% - 24px);\n    }\n}\n\n@error-color: #EB0004;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
